import styled from "styled-components";

export const MapWrapper = styled.a`
	margin: 5px;
	border-radius: 10px;
	display: flex;
	justify-content: center;

	${props => props.theme.breakpoints.down("md")} {
		margin: 10px 5px;
	}
`;
